export default __webpack_public_path__ + "static/media/chrono-red.5b98dce9.png";